import { ZfTextButton } from '@zafire/react';
import type { FunctionComponent } from 'react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { AddEventFlowModal } from './AddEventFlowModal';

export const AddEventButton: FunctionComponent = () => {
    const { t } = useTranslation();
    const [isSelectEventModalOpen, setIsSelectEventModalOpen] = useState(false);
    const onAddEvent = () => setIsSelectEventModalOpen(true);

    return (
        <>
            <ZfTextButton hierarchy="secondary" type="button" trailing-icon="add" onClick={onAddEvent} className="ml-auto">
                {t('add')}
            </ZfTextButton>
            {isSelectEventModalOpen && <AddEventFlowModal onClose={() => setIsSelectEventModalOpen(false)} />}
        </>
    );
};
